<template>
  <v-dialog v-model="dialog" width="450" persistent>
    <v-card class="edit-auto">
      <form>
        <v-toolbar color="secondary" dense>
          <v-spacer></v-spacer>
          <v-btn color="primarytext" flat @click="onSaveClick" :disabled="false">
            <v-icon left>save</v-icon>Modifica
          </v-btn>
          <v-btn icon @click="dialog = false">
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout row wrap pa-4>
          <v-flex xl6 lg6 md6>
            <v-autocomplete
              v-model="form.id_tipo_auto"
              :error-messages="errorMessage('id_tipo_auto')"
              :items="tipoList"
              @input="$v.form.id_tipo_auto.$touch()"
              item-value="id"
              hide-selected
              hide-details
              label="Tipo"
              color="tree"
              outline
              mb-4
            ></v-autocomplete>
          </v-flex>
          <v-flex xl6 lg6 md6>
            <v-text-field
              :error-messages="errorMessage('targa')"
              v-model="form.targa"
              hide-details
              color="tree"
              outline
              label="Targa"
            ></v-text-field>
          </v-flex>
          <v-flex xl6 lg6 md6>
            <v-text-field
              prepend-icon="fas fa-car"
              :error-messages="errorMessage('marca')"
              v-model="form.marca"
              color="tree"
              label="Marca"
            ></v-text-field>
          </v-flex>
          <v-flex xl6 lg6 md6>
            <v-text-field
              prepend-icon="fas fa-car-side"
              :error-messages="errorMessage('modello')"
              v-model="form.modello"
              color="tree"
              label="Modello"
            ></v-text-field>
          </v-flex>
          <v-flex xl6 lg6 md6>
            <v-autocomplete
              prepend-icon="fas fa-calendar"
              v-model="form.anno"
              :error-messages="errorMessage('anno')"
              :items="annoList"
              @input="$v.form.anno.$touch()"
              clearable
              hide-selected
              label="Anno"
              color="tree"
              mb-4
            ></v-autocomplete>
          </v-flex>
          <v-flex xl6 lg6 md6>
            <v-select
              prepend-icon="fas fa-oil-can"
              :error-messages="errorMessage('alimentazione')"
              @input="$v.form.alimentazione.$touch()"
              v-model="form.alimentazione"
              :items="alimList"
              label="Alimentazione"
              color="tree"
              mb-4
            ></v-select>
          </v-flex>
          <v-flex xl6 lg6 md6>
            <v-text-field
              prepend-icon="fas fa-id-card"
              :error-messages="errorMessage('intestatario')"
              v-model="form.intestatario"
              color="tree"
              label="Intestatario"
            ></v-text-field>
          </v-flex>
          <v-flex xl6 lg6 md6>
            <input
              type="file"
              style="display: none"
              ref="libretto"
              accept="image/*, application/pdf"
              @change="onFilePicked"
            >
            <v-btn
              v-if="!form.librettoFile"
              @click="pickFile"
              :color="!$v.form.librettoFile.$dirty ? 'tree' : 'red'"
              flat
            >
              <v-icon color="'tree'" left>attach_file</v-icon>Aggiungi libretto
            </v-btn>    
            <v-chip v-else outline color="tree">
              <v-icon left style="padding: 0 10px;">fas fa-receipt</v-icon>
              <v-tooltip right color="white" style="opacity: 1;" z-index="300">
                <span slot="activator">{{form.librettoName}}</span>
                <span>
                  <img
                    v-if="form.librettoName.split('.').pop() !== 'pdf'"
                    :src="form.librettoUrl"
                    width="250"
                  >
                  <embed
                    v-else
                    :src="form.librettoUrl"
                    width="500"
                    height="375"
                    type="application/pdf"
                  >
                </span>
              </v-tooltip>
              <v-icon
                v-if="form.librettoFile"
                style="padding: 0 5px;"
                right
                small
                color="error"
                @click.stop="onFileDettach"
              >fas fa-trash-alt</v-icon>
            </v-chip>        
          </v-flex>
        </v-layout>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

const formCampInit = {
  id: null,
  targa: null,
  id_tipo_auto: null,
  marca: null,
  modello: null,
  anno: null,
  alimentazione: null,
  librettoName: null,
  librettoFile: null,
  librettoUrl: null,
  intestatario: null
};

const tipoList = [{id: '5', text: "AUTO PRIVATA" }, {id: '4', text: "AUTO A NOLEGGIO" }];
const alimList = ["BENZINA", "DIESEL", "IBRIDA", "METANO", "ELETTRICA", "GPL"];
export default {
  name: "acc-edit-targa",
  mixins: [validationMixin],
  props: {
  },
  validations: {
    form: {
      targa: { required, maxLength: maxLength(12) },
      marca: { required },
      modello: { required },
      anno: { required },
      id_tipo_auto: { required },
      alimentazione: { required },
      librettoFile: { required: false },
      intestatario: { required }
    }
  },
  data: () => ({
    form: { ...formCampInit },
    dialog: false,
    alimList: alimList,
    tipoList: tipoList,
  }),
  watch: {
    dialog(val) {
      if (!val) {
        this.cleanDialogForm();
      }
    }
  },
  computed: {
    annoList() {
      let list = [];
      let init = 1960,
        fine = 2050;
      for (; init <= fine; init++) {
        list.push('' + init);
      }
      return list;
    }
  },
  methods: {
    open (item) {
      console.log('open', item);
      this.$nextTick(() => {
        for (var key in this.form) { this.form[key] = item[key]; }     
      })
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    errorMessage(name) {
      const errors = [];
      if (!this.$v.form[name].$dirty) return errors;
      !this.$v.form[name].required && errors.push("Obbligatorio");
      this.$v.form.hasOwnProperty("maxLength") &&
        !this.$v.form[name].maxLength &&
        errors.push("Massima lungezza 12 chrt");
      return errors;
    },
    pickFile() {
      this.$refs.libretto.click();
    },
    onFilePicked(e, indiceSpesa) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.form.librettoName = files[0].name;
        if (this.form.librettoName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.form.librettoUrl = fr.result;
          this.form.librettoFile = files[0];
        });
      } else {
        this.form.librettoName = "";
        this.form.librettoFile = "";
        this.form.librettoUrl = "";
      }
    },
    onFileDettach() {
      this.$refs.libretto.value = null;
      this.form.librettoName = "";
      this.form.librettoFile = "";
      this.form.librettoUrl = "";
    },
    cleanDialogForm() {
      this.$v.$reset();
      this.form = { ...formCampInit };
    },
    onSaveClick() {
      this.$v.form.$touch();
      if (!this.$v.form.$error) {
        this.$emit("on-update", this.form);
      }
    },
  }
};
</script>

<style lang="scss">
.edit-auto {
  .btn-row-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .v-input.v-text-field--outline {
      .v-input__slot {
        min-height: 60px !important;
      }
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/ModalEditTarga.vue